<template>
  <div class="app-container">
    <div class="app-flex-container" v-show="pageMode === 'tree'">
      <div class="app-left">
        <div style="margin-bottom: 8px;">
          <wt-auth :hasAnyPremission="form.formCode + ':ADDCOMPANY'" class="search-form-btn" style="margin-left: 0;">
            <el-button size="small" type="primary" @click="addCompany">新增</el-button>
          </wt-auth>
          <wt-auth class="search-form-btn">
            <el-button size="small" @click="toAllSite">全部站点</el-button>
          </wt-auth>
        </div>
        <el-input
          size="small"
          placeholder="输入关键字进行过滤"
          v-model="filterText">
        </el-input>
        <el-tree
          ref="orgTree"
          :data="treeData"
          :props="{ children: 'childList', label: 'name' }"
          :filter-node-method="filterNode"
          :expand-on-click-node="false"
          default-expand-all
          node-key="id"
          highlight-current
          @current-change="currentChange">
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <el-tooltip class="item" effect="dark" :content="data.name" :disabled="data.name.length <= 10" placement="top">
              <span class="text">{{ data.name }}</span>
            </el-tooltip>
            <span class="icon-btn">
              <wt-auth :hasAnyPremission="form.formCode + ':EDITCOMPANY'" class="search-form-btn" style="margin-left: 0;">
                <span class="el-icon-edit" @click.stop="() => handleEditTree(data)"></span>
              </wt-auth>
              <wt-auth :hasAnyPremission="form.formCode + ':DELETECOMPANY'" class="search-form-btn" style="margin-left: 6px;">
                <span class="el-icon-remove-outline" @click.stop="() => handleDeleteTree(data)"></span>
              </wt-auth>
              <wt-auth :hasAnyPremission="form.formCode + ':ADDCOMPANY'" class="search-form-btn" style="margin-left: 6px;">
                <span class="el-icon-circle-plus-outline" v-if="data.level !== '3'" @click.stop="() => handleAddTree(data, node)"></span>
              </wt-auth>
            </span>
          </span>
        </el-tree>
      </div>
      <div class="app-right">
        <wt-form-table :form.sync="form" ref="treeSiteTable" @on-button-action="onButtonAction" v-if="currentTreeNode">
          <wt-form-table-list ref="siteManageTableRef" slot="wtFormTableList" :form.sync="form" @on-button-action="onButtonAction" @request-form-list="requestFormList">
            <template slot="isPublish" slot-scope="data">
              <span>{{ data.row.isPublish === 1 ? '正常' : '禁用' }}</span>
            </template>
            <template slot="isDeliveryEnabled" slot-scope="data">
              <span>{{ data.row.isDeliveryEnabled === 0 ? '是' : '否' }}</span>
            </template>
            <template slot="wtFormTableListButtonsAfter" slot-scope="scope">
               <wt-auth v-if="scope.row.isImport !== 0" :hasAnyPremission="form.formCode + ':EDITSITE'" class="search-form-btn">
                 <el-button size="mini" type="primary" @click="onButtonAction({...scope, item: {key: 'EDIT', action: 'EDIT', className: 'primary', hidden: false, permission: 'EDITSITE'}})">编辑</el-button>
               </wt-auth>
               <wt-auth v-if="scope.row.isPublish" :hasAnyPremission="form.formCode + ':USABLE'" class="search-form-btn">
                 <el-button size="mini" type="primary" @click="toClickAction(scope.row)">禁用</el-button>
               </wt-auth>
               <wt-auth v-if="!scope.row.isPublish" :hasAnyPremission="form.formCode + ':USABLE'" class="search-form-btn">
                 <el-button size="mini" type="primary" @click="toClickAction(scope.row)">启用</el-button>
               </wt-auth>
            </template>
          </wt-form-table-list>
        </wt-form-table>
      </div>
    </div>
    <div v-if="pageMode === 'list'">
      <div style="margin-bottom: 8px;">
        <el-button size="small" @click="pageMode = 'tree'">返回</el-button>
      </div>
      <all-site-list></all-site-list>
    </div>

    <wt-detail-page :visible.sync="treeAddVisible" :detail-data="treeEditData" component-name="SiteOrganizationEditPage" component-type="add" @on-dialog-action="onDialogAction" />
    <wt-detail-page :visible.sync="treeEditVisible" :detail-data="treeEditData" component-name="SiteOrganizationEditPage" component-type="edit" @on-dialog-action="onDialogAction" />
  </div>
</template>

<script>
import AllSiteList from './allSiteList.vue'
export default {
  name: 'SiteIndex',
  components: { AllSiteList },
  data() {
    return {
      filterText: '',
      treeData: [],
      treeAddVisible: false,
      treeEditVisible: false,
      treeEditData: {},
      currentTreeNode: null,
      pageMode: 'tree', // list
      form: { //  表单数据
        isFormLoading: false,
        formCode: 'MODULE_SITE_INDEX',
        formComponent: {
          list: { type: 'default', value: '/modules/site/siteList' },
          delete: { type: 'default', value: '/modules/site/siteDelete' },
          add: {
            type: 'component', componentName: 'SiteIndexEditPage', value: 'resetSiteDetailData', detailData: {}},
          edit: {
            type: 'component', componentName: 'SiteIndexEditPage', value: 'setSiteDetailData', detailData: {}},
          view: {
            type: 'component', componentName: 'SiteIndexViewPage', value: 'setSiteDetailData', detailData: {}}
        },
        formInputsData: [
          { name: '站点名称', key: 'name', value: '', type: 'text' },
          // { name: '机构', key: 'orgId', value: '', type: 'cascader', options: [], props: { checkStrictly: true, children: 'childList', label: 'name', value: 'id', emitPath: false, expandTrigger: 'hover' }},
          { name: '状态',
            key: 'isPublish',
            value: '',
            type: 'select',
            data: [
              { label: '全部', value: '' },
              { label: '正常', value: 1 },
              { label: '禁用', value: 0 }
            ] },
          { name: '机构', key: 'orgId', value: '', type: 'customAllFixed', display: 'more' },
          { name: '层级', key: 'level', value: '', type: 'customAllFixed', display: 'more' }],
        formButtonsData: [],
        formTableData: [
          { name: '站点名称', key: 'name', type: 'text' },
          { name: '社区名称', key: 'communityName', type: 'text' },
          { name: '物业总名称', key: 'name1', type: 'text' },
          { name: '物业分名称', key: 'name2', type: 'text' },
          { name: '项目部', key: 'name3', type: 'text' },
          { name: '站点位置', key: 'address', type: 'text' },
          { name: '户数', key: 'house', type: 'text' },
          { name: '是否开通投递功能', key: 'isDeliveryEnabled', type: 'custom' },
          { name: '状态', key: 'isPublish', type: 'custom' }],
        formTableButtonsData: [{ name: '查看', key: 'VIEW', action: 'VIEW', className: 'primary', hidden: false, permission: 'VIEW' }
          // { name: '编辑', key: 'EDIT', action: 'EDIT', className: 'primary', hidden: false, permission: 'EDITSITE' }
        ],
        formResult: {},
        pageData: { currentPage: 0, pageSize: 20, sortName: '', sortOrder: '' },
        formTableProp: { selection: true, index: true, buttonWidth: 190 }
      },
      formDialog: {
        visible: true,
        title: ''
      }
    }
  },
  watch: {
    filterText(val) {
      this.$refs.orgTree.filter(val)
    }
  },
  mounted() {
    this.orgTreeAllListNoSite()
  },
  methods: {
    currentChange(data) {
      if (data.level === '3') {
        this.form.formButtonsData = [
          { name: '新增', key: 'ADD', action: 'ADD', className: 'primary', hidden: false, permission: 'ADDSITE' },
          { name: '删除', key: 'DELETE', action: 'DELETE_LIST', className: 'danger', hidden: false, permission: 'DELETESITE' },
          { name: '开通投递站点', key: 'OPEN', action: 'OPEN_LIST', className: 'primary', hidden: false, permission: 'EDITSITE' },
          { name: '关闭投递站点', key: 'CLOSE', action: 'CLOSE_LIST', className: 'primary', hidden: false, permission: 'EDITSITE' },
          {
            name: '批量导入',
            key: 'IMPORT',
            action: 'IMPORT',
            hidden: false,
            permission: 'IMPORT',
            type: 'IMPORT',
            url: window.wtConst.BASE_API + '/modules/site/siteListImport',
            exrtaImportData: {
              id: data.id }},
          { name: '模板下载',
            key: 'DOWNLOAD',
            action: 'DOWNLOAD',
            hidden: false,
            permission: 'DOWNLOAD'
          }
        ]
      } else {
        this.form.formButtonsData = [
          { name: '开通投递站点', key: 'OPEN', action: 'OPEN_LIST', className: 'primary', hidden: false, permission: 'EDITSITE' },
          { name: '关闭投递站点', key: 'CLOSE', action: 'CLOSE_LIST', className: 'primary', hidden: false, permission: 'EDITSITE' },
          {
            name: '批量导入',
            key: 'IMPORT',
            action: 'IMPORT',
            hidden: false,
            permission: 'IMPORT',
            type: 'IMPORT',
            url: window.wtConst.BASE_API + '/modules/site/siteListImport',
            exrtaImportData: {
              id: data.id }}
        ]
      }
      this.form.formInputsData[2].value = data.id
      this.form.formInputsData[3].value = data.level
      this.currentTreeNode = null
      this.$nextTick(() => {
        this.currentTreeNode = data
      })
    },
    addCompany() {
      this.treeEditData = { level: 1 }
      this.treeAddVisible = true
    },
    toAllSite() {
      this.pageMode = 'list'
    },
    onButtonAction(data) {
      if (data && data.item) {
        if (data.item.action === 'ADD') {
          const node = this.$refs.orgTree.getNode(this.currentTreeNode.id)
          let row = {}
          if (this.currentTreeNode.level === '1') {
            row = { id1: this.currentTreeNode.id }
          }
          if (this.currentTreeNode.level === '2') {
            row = { id1: node.parent.data.id, id2: this.currentTreeNode.id }
          }
          if (this.currentTreeNode.level === '3') {
            row = { id1: node.parent.parent.data.id, 'id2': node.parent.data.id, orgId: this.currentTreeNode.id }
          }
          this.form.formComponent.add.detailData = {
            row: row,
            parent: this.currentTreeNode
          }
        }
        if (data.item.action === 'EDIT') {
          console.log('EDIT', data)
          this.$refs.siteManageTableRef.toEdit(data.item, data.row)
          this.form.formComponent.edit.detailData = {
            row: data.row,
            parent: this.currentTreeNode
          }
        }
        if (data.item.action === 'DOWNLOAD') {
          // this.$wtUtil.downloadFileByUrl('https://ks3-external-huabei-1.bthcloud.com/shoukai-garbage/template/%E7%AB%99%E7%82%B9%E6%A8%A1%E6%9D%BF.xlsx')
          this.$wtUtil.downloadFileByUrl('https://ks3-external-huabei-1.bthcloud.com/shoukai-garbage/template/%E7%AB%99%E7%82%B9%E6%A8%A1%E6%9D%BF%EF%BC%88%E6%96%B0%E7%89%88%EF%BC%89.xlsx')
        }
        if (data.item.action === 'OPEN_LIST' || data.item.action === 'CLOSE_LIST') {
          console.log(data, this.$refs.siteManageTableRef.selectedListId())
          const ids = this.$refs.siteManageTableRef.selectedListId()
          if (ids.length === 0) {
            return this.$message({ message: '请选择要操作的站点', type: 'warning' })
          }
          const that = this
          this.$wtUtil.deleteConfirm(this, data.item.action === 'OPEN_LIST' ? '确认开启？' : '确认关闭？').then(() => {
            that.$api.siteManage.site.siteOpenOrCloseDelivery({
              siteIds: ids,
              isDeliveryEnabled: data.item.action === 'OPEN_LIST' ? 0 : 1
            }).then(res => {
              that.$message({ message: '操作成功', type: 'success' })
              that.$refs.siteManageTableRef.requestList()
            })
          })
        }
      }
    },
    toClickAction(row, type) {
      const that = this
      this.$wtUtil.deleteConfirm(this, row.isPublish === 1 ? '确认禁用？' : '确认启用？').then(() => {
        that.$api.siteManage.site.siteIsPublish({
          id: row.id
        }).then(res => {
          that.$message({ message: '操作成功', type: 'success' })
          that.$refs.siteManageTableRef.requestList()
        })
      })
    },
    handleEditTree(data) {
      this.treeEditData = data
      this.treeEditVisible = true
    },
    handleDeleteTree(data) {
      const that = this
      this.$confirm('是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.$api.siteManage.org.orgDelete({
          list: [data.id]
        }).then(res => {
          that.orgTreeAllListNoSite()
          // that.$message({ message: '操作成功', type: 'success' })
          // that.$refs.siteManageTableRef.requestList()
        })
      }).catch(() => {})
    },
    handleAddTree(data, node) {
      this.treeEditData = { level: data.level * 1 + 1, parentid: data.id }
      this.treeAddVisible = true
    },
    filterNode(value, data) {
      if (!value) return true
      return data.name.indexOf(value) !== -1
    },
    onDialogAction(type) {
      if (type === 'close') {
        this.treeAddVisible = false
        this.treeEditVisible = false
      }
      if (type === 'refresh') {
        this.orgTreeAllListNoSite()
      }
    },
    requestFormList() {
      this.$refs.treeSiteTable.requestFormList()
    },
    /*  ------------------------- 接口请求  -------------------------  */
    orgTreeAllListNoSite() {
      const c = []
      this.$api.siteManage.org.orgTreeAllListNoSite().then(res => {
        this.$wtUtil.setTreeToList('childList', c, res.data)
        this.treeData = res.data
        if (res.data && res.data.length) {
          this.$nextTick(() => {
            if (this.currentTreeNode && c.find(item => { return item.id === this.currentTreeNode.id })) {
              this.$refs.orgTree.setCurrentKey(this.currentTreeNode.id)
              this.currentChange(c.find(item => { return item.id === this.currentTreeNode.id }))
            } else {
              this.$refs.orgTree.setCurrentKey(res.data[0].id)
              this.currentChange(res.data[0])
            }
          })
        }
      })
    }
  }
}
</script>

<style>
</style>
